import { initialize } from '@guiker/i18n'

export * from '@guiker/i18n'

const i18n = initialize()

export { i18n }
